import { TbCopy } from 'react-icons/tb'
import "highlight.js/styles/github.css";
import { useEffect, useState } from 'react';
import hljs from 'highlight.js';
import { Editor } from '@monaco-editor/react';

interface Props {
  content: string
  language?: string
  title?: string
  textSize?: 'small' | 'normal'
  bgColor?: string
}

const CodeDisplay = (props: Props) => {

  const [editorHeight, setEditorHeight] = useState(200);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    hljs.highlightAll();
  }, []);

  const handleEditorDidMount = (editor: any) => {
    if (mounted) return;
    try {
      editor.onDidContentSizeChange(() => {
        setTimeout(() => {
          const newHeight = Math.min(Math.max(editor.getContentHeight(), 10), 1000);
          setEditorHeight(newHeight);
          setMounted(true);
          console.log(newHeight);
        }, 10);
      });
    } catch (error) {
      console.error(error);      
    }
  };

  return (
    <div className='code-display w-full text-sm overflow-x-auto h-auto'>
      <div className='relative w-full rounded-xl overflow-auto mt-2 bg-gray-100' style={props.bgColor ? { background: props.bgColor } : {}}>
        <div className='flex items-center justify-between p-1.5 border-b'>
          <div className={`ml-4 text-xs ${props.textSize === 'small' ? '' : 'md:text-sm'}`}>{props.title}</div>
          <div className='flex items-center'>
            <div className='mr-3 text-gray-400'>{props.language || 'json'}</div>
            <button onClick={() => navigator.clipboard.writeText(props.content)} className='h-6 w-6 text-sm bg-white rounded-md flex items-center justify-center hover:text-primary'><TbCopy /></button>
          </div>
        </div>
        <div className={`text-xs ${props.textSize === 'small' ? '' : 'md:text-sm'} h-auto px-2 py-1`}>
          <Editor
            className='code-editor-display'
            width={'100%'}
            height={editorHeight}
            language={props.language || 'json'}
            value={props.content}
            onMount={handleEditorDidMount}
            options={{
              minimap: { enabled: false },
              scrollBeyondLastLine: false,
              renderLineHighlight: "none",
              readOnly: true,
              wordWrap: "off",
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default CodeDisplay